export default "__VITE_ASSET__6376e049__"